import { useI18n } from "react-simple-i18n";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { FirstButton } from "../buttons/buttons";

interface VideoUploadProps {
	error?: boolean
	videoPreview: string
	handleVideoUpload: (file: any) => void
}

const VideoUpload = ({ videoPreview, error = false, handleVideoUpload }: VideoUploadProps) => {
	const { t } = useI18n();
	const onFileChange = ({ target }: any) => {
		const file = target.files?.[0];
		if (file && file.type.startsWith('video/')) {
			handleVideoUpload(file);
		}
	}

	return (
		<VideoUploadSection error={error ? "true" : ""}>
			{videoPreview && (
				<VideoPreviewWrapper>
					<video controls src={videoPreview}
						style={{ maxWidth: '100%', maxHeight: '400px' }}
					/>
				</VideoPreviewWrapper>
			)}

			<Box className="button-wrapper">
				<input type="file" accept="video/*"
					onChange={onFileChange}
				/>

				<FirstButton startIcon={<CloudUploadIcon />}>
					<Typography variant="body1">{t("buttons.uploadVideo")}</Typography>
				</FirstButton>
			</Box>
		</VideoUploadSection>
	)
}

const VideoUploadSection = styled(Box)<{ error: string }>(({ theme, error }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: theme.spacing(3),

	borderRadius: 5,
	padding: theme.spacing(3),
	border: `2px dashed ${error ? theme.palette.common.fourthColor : theme.palette.common.firstBorder}`,

	".button-wrapper": {
		position: "relative",

		input: {
			zIndex: 2,
			top: 0, left: 0,
			position: "absolute",
			width: "100%", height: "100%",
			cursor: "pointer",
			opacity: 0,
		}
	},

	[theme.breakpoints.down("md")]: {
		gap: theme.spacing(1),
		padding: theme.spacing(1.5),
		marginTop: theme.spacing(0),
	}
}))

const VideoPreviewWrapper = styled(Box)(({ theme }) => ({
	width: '100%',
	display: 'flex',
	justifyContent: 'center',
}))

export { VideoUpload }